var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconInfoGrey = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M11 7H9V5h2zm0 8H9V9h2zm-.99 5C15.53 20 20 15.52 20 10S15.53 0 10.01 0C4.48 0 0 4.48 0 10s4.48 10 10.01 10M10 2c4.42 0 8 3.58 8 8s-3.58 8-8 8-8-3.58-8-8 3.58-8 8-8"
})));
export { SvgIconInfoGrey as ReactComponent };
export default __webpack_public_path__ + "img/icon-info-grey.006a67add0f2e1df3d7433597f4d66b0.svg";